module.exports = __webpack_public_path__ + "img/POSTerminal.1b724a97.svg";